import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instancekqccuusv4qnz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      o3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      w6p(writer, customScalarAdapters, value) {
        writer.r47('partyId');
        get_partyIdAdapter().p3z(writer, customScalarAdapters, value.m6o_1);
        writer.r47('playerId');
        get_playerIdAdapter().p3z(writer, customScalarAdapters, value.n6o_1);
        writer.r47('name');
        get_StringAdapter().p3z(writer, customScalarAdapters, value.o6o_1);
        writer.r47('email');
        get_StringAdapter().p3z(writer, customScalarAdapters, value.p6o_1);
        writer.r47('badge');
        Badge_ResponseAdapter_instance.y6j(writer, customScalarAdapters, value.q6o_1);
        writer.r47('callSignAdjective');
        get_StringAdapter().p3z(writer, customScalarAdapters, value.r6o_1);
        writer.r47('callSignNoun');
        get_StringAdapter().p3z(writer, customScalarAdapters, value.s6o_1);
        var tmp = value.t6o_1;
        if (tmp instanceof Present()) {
          writer.r47('imageURL');
          present(get_NullableStringAdapter()).y40(writer, customScalarAdapters, value.t6o_1);
        }
        var tmp_0 = value.u6o_1;
        if (tmp_0 instanceof Present()) {
          writer.r47('avatarType');
          present(get_NullableStringAdapter()).y40(writer, customScalarAdapters, value.u6o_1);
        }
        writer.r47('unvalidatedEmails');
        list(get_StringAdapter()).w40(writer, customScalarAdapters, value.v6o_1);
      }
      p3z(writer, customScalarAdapters, value) {
        return this.w6p(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instancertyni6zcgh3z,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
